import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import "./stylesBetsReport.css";

import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";

import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Select, message } from "antd";
import CustomAutoCompleteControlled from "../../CommonComponents/CustomAutoComplete/CustomAutoCompleteControlled";
import DragAndDropTable from "./DragAndDropTable/DragAndDropTable";
import { DragOutlined, FullscreenOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { useSelector } from "react-redux";
import FeatureFlagGuard from "../../FeatureFlagGuard/FeatureFlagGuard";
import { getAdminNow } from "../../../utils/dateService";

const initialColumnsState = [
  {
    title: AppStrings.PROVIDER,
    dataIndex: "provider",
    key: "provider",
    initialWidth: 150,
    columnIndex: 0,
  },
  {
    title: AppStrings.CCF,
    dataIndex: "ccf",
    key: "ccf",
    initialWidth: 80,
    columnIndex: 1,
  },
  {
    title: AppStrings.ID,
    dataIndex: "id",
    key: "id",
    initialWidth: 100,
    columnIndex: 2,
  },
  {
    title: AppStrings.USER_ID,
    dataIndex: "userId",
    key: "userId",
    initialWidth: 100,
    columnIndex: 3,
  },
  {
    title: AppStrings.TIME,
    dataIndex: "dateTime",
    key: "dateTime",
    initialWidth: 150,
    columnIndex: 4,
  },
  {
    title: AppStrings.SPORT,
    dataIndex: "sport",
    key: "sport",
    initialWidth: 100,
    columnIndex: 5,
  },
  {
    title: AppStrings.LEAGUE,
    dataIndex: "league",
    key: "league",
    initialWidth: 150,
    columnIndex: 6,
  },
  {
    title: AppStrings.MARKET,
    dataIndex: "market",
    key: "market",
    initialWidth: 200,
    columnIndex: 7,
  },
  {
    title: AppStrings.SELECTION,
    dataIndex: "selection",
    key: "selection",
    initialWidth: 200,
    columnIndex: 8,
  },
  {
    title: AppStrings.ODDS,
    dataIndex: "odds",
    key: "odds",
    initialWidth: 200,
    columnIndex: 9,
  },
  {
    title: AppStrings.BET_TYPE,
    dataIndex: "betType",
    key: "betType",
    initialWidth: 200,
    columnIndex: 10,
  },
  {
    title: AppStrings.LIVE,
    dataIndex: "preMatchLive",
    key: "preMatchLive",
    initialWidth: 200,
    columnIndex: 11,
  },
  {
    title: AppStrings.BET_AMOUNT,
    dataIndex: "wagerAmount",
    key: "wagerAmount",
    initialWidth: 200,
    columnIndex: 12,
  },
  {
    title: AppStrings.STATUS,
    dataIndex: "status",
    key: "status",
    initialWidth: 200,
    columnIndex: 13,
  },
  {
    title: AppStrings.POTENTIAL_PAYOUT,
    dataIndex: "payout",
    key: "payout",
    initialWidth: 200,
    columnIndex: 14,
  },
]

function BetsReport({ children = undefined }) {
  const { appConfig } = useSelector((state) => state.config);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );
  const columnsState = JSON.parse(localStorage.getItem("columnsState")) || initialColumnsState;
  const todayRange = [getAdminNow(), getAdminNow()];
  const filtersRef = useRef({});

  const [messageApi, contextHolder] = message.useMessage();

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [showExtraFilters, setShowExtraFilters] = useState(false);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const filtersAppliedRef = useRef(filtersApplied);

  const [selectedSports, setSelectedSports] = useState(null);
  const [selectedLeagues, setSelectedLeagues] = useState(null);
  const [selectedOddProvider, setSelectedOddProvider] = useState(null);
  const [selectedMinBetAmount, setSelectedMinBetAmount] = useState(null);
  const [selectedBetType, setSelectedBetType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [selectedMarketType, setSelectedMarketType] = useState(null);
  const [selectedMinCCF, setSelectedMinCCF] = useState(null);
  const [selectedMaxCCF, setSelectedMaxCCF] = useState(null);
  const [selectedPreMatchLive, setSelectedPreMatchLive] = useState(null);
  const [selectedMoneyType, setSelectedMoneyType] = useState(null);

  const [scrolledDown, setScrolledDown] = useState(false);
  const [runWebSocket, setRunWebSocket] = useState(false);

  const [expandAllRows, setExpandAllRows] = useState(false);

  const columns = columnsState;

  const [modeState, setModeState] = useState("resize");

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [sports, setSports] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [matches, setMatches] = useState([]);
  const [marketTypes, setMarketTypes] = useState([
    {
      value: "moneyline",
      label: AppStrings.MONEYLINE,
    },
    {
      value: "spread",
      label: AppStrings.SPREAD,
    },
    {
      value: "total",
      label: AppStrings.TOTAL,
    },
  ]);
  const [minCCF, setMinCCF] = useState([]);
  const [maxCCF, setMaxCCF] = useState([]);
  const [statuses, setStatuses] = useState([
    {
      value: "Accepted",
      label: AppStrings.ACCEPTED,
    },
    {
      value: "Rejected",
      label: AppStrings.REJECTED,
    },
  ]);
  const [oddsProviders, setOddsProviders] = useState([]);
  const preMatchLive = [
    {
      value: "live",
      label: AppStrings.LIVE,
    },
    {
      value: "prematch",
      label: AppStrings.PRE_MATCH,
    },
    {
      value: "500",
      label: AppStrings.FIVE_HUNDRED_TO_SIX_HUNDRED,
    },
  ];

  const betTypes = [
    {
      value: "Straight",
      label: AppStrings.STRAIGHT,
    },
    {
      value: "Parlay",
      label: AppStrings.PARLAY,
    },
    {
      value: "Round Robin",
      label: AppStrings.ROUND_ROBIN,
    },
    {
      value: "Grouped",
      label: AppStrings.GROUPED,
    },
  ];
  const moneyTypes = [
    {
      value: null,
      label: AppStrings.ALL,
    },
    {
      value: appConfig?.app_currency_config?.primary_currency?.shortcode,
      label: appConfig?.app_currency_config?.primary_currency?.name,
    },
    {
      value: appConfig?.app_currency_config?.secondary_currency?.shortcode,
      label: appConfig?.app_currency_config?.secondary_currency?.name,
    },
    {
      value: "rebet_free_cash",
      label: AppStrings.FREE_CASH,
    },
  ]?.filter((moneyType) => moneyType.label !== null);

  const [betsToShowInTable, setBetsToShowInTable] = useState([]);

  const [pendingBets, setPendingBets] = useState([]);

  const [allBetsToShowInTable, setAllBetsToShowInTable] = useState([]);
  const [allPendingBets, setAllPendingBets] = useState([]);

  const [filterType, setFilterType] = useState("all");
  const tableRef = useRef(null);
  const isAtTop = useRef(true);

  const getBetsReport = async (queryString = todayRange) => {
    let startDate = "";
    let endDate = "";

    startDate = queryString[0]?.format("YYYY-MM-DD");
    endDate = queryString[1]?.format("YYYY-MM-DD");

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsApiRunning(true);

      const requests = [
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_SPORTSBOOK_OVERVIEW,
          params
        ),
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_POPULAR_MARKETS,
          params
        ),
      ];
      const responses = await Promise.allSettled(requests);

      const [sportsbookOverviewResponse, popularMarketsResponse] = responses;

      if (sportsbookOverviewResponse.status === "fulfilled") {
        const data = sportsbookOverviewResponse?.value?.data?.data;

        const leagues = data.league_names.map((league) => {
          return {
            value: league,
            label: league,
          };
        });

        const sports = data.sport_names.map((sport) => {
          return {
            value: sport,
            label: sport,
          };
        });

        const odds_providers = data.odds_providers.map((odds_provider) => {
          return {
            value: odds_provider,
            label: odds_provider,
          };
        });
        const matches = data.event_ids.map((event_id) => {
          return {
            value: event_id,
            label: event_id,
          };
        });
        setLeagues(leagues);
        setSports(sports);
        setOddsProviders(odds_providers);
        setMatches(matches);
      }

      if (popularMarketsResponse.status === "fulfilled") {
        const data = popularMarketsResponse?.value?.data?.data?.top_markets || [];

        const marketTypes = data.map((market) => {
          return {
            value: market.market_name,
            label: market.market_name,
          };
        });
        setMarketTypes((prev) => [...prev, ...marketTypes]);
      }
      setRunWebSocket(true);
    } catch (error) {
      console.log("Error adding event code:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleBetTypeChange = (value) => {
    setSelectedBetType(value);
  };

  const handleBetAmountChange = (value) => {
    setSelectedMinBetAmount(value);
  };

  const handleLeagueChange = (value) => {
    setSelectedLeagues(value);
  };

  const handleOddProviderChange = (value) => {
    setSelectedOddProvider(value);
  };

  const handleSportChange = (value) => {
    setSelectedSports(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handlePreMatchLiveChange = (value) => {
    setSelectedPreMatchLive(value);
  };

  const handleMatchChange = (value) => {
    setSelectedMatch(value);
  };

  const handleMarketTypeChange = (value) => {
    setSelectedMarketType(value);
  };

  const handleMinCCFChange = (value) => {
    setSelectedMinCCF(value);
  };

  const handleMaxCCFChange = (value) => {
    setSelectedMaxCCF(value);
  };

  const handleMoneyTypeChange = (value) => {
    setSelectedMoneyType(value);
  };

  const handleClearFilters = () => {
    setSelectedSports(null);
    setSelectedBetType(null);
    setSelectedMinBetAmount(null);
    setSelectedLeagues(null);
    setSelectedOddProvider(null);
    setSelectedStatus(null);
    setSelectedPreMatchLive(null);
    setSelectedMatch(null);
    setSelectedMarketType(null);
    setSelectedMinCCF(null);
    setSelectedMaxCCF(null);
    setSelectedMoneyType(null);
    setFiltersApplied(false);
    message.success(AppStrings.FILTERS_CLEARED);
  };

  const handleApplyFilters = () => {
    filtersRef.current = {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    };
    setFiltersApplied(true);
    filtersAppliedRef.current = true;
    message.success(AppStrings.FILTERS_APPLIED);
  };


  const handleExpandAllRows = () => {
    setExpandAllRows(!expandAllRows);
  };

  useEffect(() => {
    getBetsReport();
  }, []);

  useLayoutEffect(() => {
    filtersRef.current = {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    };
    const passesFilters = (row) =>
      shouldIncludeData(row) &&
      (filterType === "all" || row.money_type === filterType);
    if (filtersApplied) {
      setBetsToShowInTable(allBetsToShowInTable.filter(passesFilters));
      setPendingBets(allPendingBets.filter(passesFilters));
    } else {
      setBetsToShowInTable(allBetsToShowInTable);
      setPendingBets(allPendingBets);
    }
  }, [
    filtersApplied,
    allBetsToShowInTable,
    allPendingBets,
    filterType,
    selectedSports,
    selectedLeagues,
    selectedMatch,
    selectedMinBetAmount,
    selectedBetType,
    selectedMarketType,
    selectedMinCCF,
    selectedMaxCCF,
    selectedOddProvider,
    selectedStatus,
    selectedPreMatchLive,
    selectedMoneyType,
  ]);

  const shouldIncludeData = (data) => {
    const {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    } = filtersRef.current;

    if (selectedSports && typeof selectedSports === "string") {
      const selectedTrimmed = selectedSports.trim();
      if (selectedTrimmed) {
        const dataSport = Array.isArray(data.sport) ? data.sport : data.sport != null ? [data.sport] : [];
        // Row must contain only the selected sport (exclude rows with multiple sports where one is different)
        const sportMatches =
          dataSport.length > 0 &&
          dataSport.every(
            (ds) => String(ds).trim().toLowerCase() === selectedTrimmed.toLowerCase()
          );
        if (!sportMatches) return false;
      }
    }

    if (selectedLeagues && typeof selectedLeagues === "string") {
      const selectedTrimmed = selectedLeagues.trim();
      if (selectedTrimmed) {
        const dataLeague = Array.isArray(data.league) ? data.league : data.league != null ? [data.league] : [];
        // Row must contain only the selected league (exclude rows with multiple leagues where one is different)
        const leagueMatches =
          dataLeague.length > 0 &&
          dataLeague.every(
            (dl) => String(dl).trim().toLowerCase() === selectedTrimmed.toLowerCase()
          );
        if (!leagueMatches) return false;
      }
    }

    if (selectedMatch && !selectedMatch.includes(data.eventId)) return false;

    if (
      selectedMinBetAmount !== null &&
      data.wagerAmount <= selectedMinBetAmount
    )
      return false;

    if (selectedBetType && data.betType !== selectedBetType) return false;

    if (selectedMarketType) {
      const marketArr = Array.isArray(data.market) ? data.market : [data.market];
      const match = marketArr?.some((m) =>
        m?.toLowerCase().includes(selectedMarketType.toLowerCase())
      );
      if (!match) return false;
    }

    if (selectedMinCCF !== null && data.ccf <= selectedMinCCF) return false;

    if (selectedMaxCCF !== null && data.ccf >= selectedMaxCCF) return false;

    if (selectedOddProvider) {
      const selectedOddProviderArray = selectedOddProvider
        .split(",")
        .map((s) => s.trim());
      if (
        !selectedOddProviderArray.some((provider) =>
          data.provider?.includes(provider)
        )
      ) {
        return false;
      }
    }

    if (selectedStatus && data.status !== selectedStatus) return false;

    if (
      selectedPreMatchLive !== null &&
      data.preMatchLive !== selectedPreMatchLive
    )
      return false;

    if (selectedMoneyType && data.money_type !== selectedMoneyType)
      return false;

    return true;
  };

  const wsRef = useRef(null);
  const filterTypeRef = useRef(filterType);

  const messageBuffer = useRef([]);
  const flushTimer = useRef(null);
  let uniqueIdCounter = 0;

  const flushBuffer = () => {
    if (messageBuffer.current.length === 0) return;

    const bufferedMessages = [...messageBuffer.current];
    messageBuffer.current = [];

    bufferedMessages.forEach((rawData, index) => {
      try {
        const data = JSON.parse(rawData);

        const {
          selectedSports,
          selectedLeagues,
          selectedMatch,
          selectedMinBetAmount,
          selectedBetType,
          selectedMarketType,
          selectedMinCCF,
          selectedMaxCCF,
          selectedOddProvider,
          selectedStatus,
          selectedPreMatchLive,
          selectedMoneyType,
        } = filtersRef.current || {};

        if (filtersAppliedRef.current && !shouldIncludeData(data)) return;

        let filteredData = data;
        if (filterTypeRef.current !== "all") {
          filteredData =
            filteredData.money_type === filterTypeRef.current
              ? filteredData
              : null;
        }
        if (!filteredData) return;
        filteredData.customId = uniqueIdCounter++;

        const sports = filteredData.sport.split(",").map((s) => s.trim());
        const leagues = filteredData.league.split(",").map((s) => s.trim());
        const markets = filteredData.market.split(" + ").map((s) => s.trim());
        const selections = filteredData.selection
        .split(" + ")
        .map((s) => s.trim());
        
        filteredData.dateTime = filteredData.dateTime.split(" ")[1];
        filteredData.sport = sports;
        filteredData.league = leagues;
        filteredData.market = markets;
        filteredData.selection = selections;

        const transformedData = filteredData;
        const setAllSetter = isAtTop.current
          ? setAllBetsToShowInTable
          : setAllPendingBets;
        setAllSetter((prev) => {
          const newData = [transformedData, ...prev].slice(0, 50);
          return newData;
        });
      } catch (e) {
        console.error("❌ Erro ao processar mensagem WS:", e);
      }
    });
  };

  useEffect(() => {
    filterTypeRef.current = filterType;
  }, [filterType]);

  useEffect(() => {
    filtersAppliedRef.current = filtersApplied;
  }, [filtersApplied]);

  useEffect(() => {
    if (!runWebSocket) return;

    const websocketUrl = process.env.REACT_APP_BET_TICKER_WS_URL;
    const ws = new WebSocket(websocketUrl);
    wsRef.current = ws;

    flushTimer.current = setInterval(flushBuffer, 2000);

    ws.onopen = () => {
      console.log("WebSocket connection opened");
    };

    ws.onmessage = (message) => {
      messageBuffer.current.push(message.data);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };

    ws.onerror = (err) => {
      console.error("Erro WebSocket:", err);
    };

    return () => {
      if (ws.readyState < 2) {
        ws.close();
      }
      clearInterval(flushTimer.current);
    };
  }, [runWebSocket]);

  useEffect(() => {
    const checkScroll = () => {
      const scrollContainer = tableRef.current?.querySelector(
        ".drag-and-drop-table-container"
      );
      if (!scrollContainer) return;

      const atTop = scrollContainer.scrollTop === 0;
      isAtTop.current = atTop;
      setScrolledDown(!atTop);

      if (atTop && allPendingBets.length > 0) {
        setAllBetsToShowInTable((prev) => {
          const combined = [...allPendingBets, ...prev];
          return combined.slice(0, 100);
        });
        setAllPendingBets([]);
      }
    };

    const interval = setInterval(() => {
      const scrollContainer = tableRef.current?.querySelector(
        ".drag-and-drop-table-container"
      );
      if (scrollContainer && !scrollContainer.dataset.listenerAttached) {
        scrollContainer.dataset.listenerAttached = "true";
        scrollContainer.addEventListener("scroll", checkScroll);
        checkScroll();
      }
    }, 100);

    return () => clearInterval(interval);
  }, [allPendingBets]);

  useEffect(() => {
    filtersRef.current = {
      selectedSports,
      selectedLeagues,
      selectedMatch,
      selectedMinBetAmount,
      selectedBetType,
      selectedMarketType,
      selectedMinCCF,
      selectedMaxCCF,
      selectedOddProvider,
      selectedStatus,
      selectedPreMatchLive,
      selectedMoneyType,
    };
  }, [
    selectedSports,
    selectedLeagues,
    selectedMatch,
    selectedMinBetAmount,
    selectedBetType,
    selectedMarketType,
    selectedMinCCF,
    selectedMaxCCF,
    selectedOddProvider,
    selectedStatus,
    selectedPreMatchLive,
    selectedMoneyType,
  ]);

  return (
    <div className="betsReport-container">
      <div className="betsReport">
        {contextHolder}
        <>
          <div className="head-controls">
            <div className="betsReport-autocomplete-container">
              <div
                className="filter-buttons"
                data-testid="filter-toggle"
                role="button"
                tabIndex={0}
                onClick={() => setShowExtraFilters(!showExtraFilters)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowExtraFilters(!showExtraFilters)}
              >
                <Filter className="filter-icon" />
                {showExtraFilters ? (
                  <ChevronUp className="filter-icon" />
                ) : (
                  <ChevronDown className="filter-icon" />
                )}
              </div>
              </div>
          </div>

          <div className="betsReport-content">
            <div className="betsReport-content-header"
            style={{ display: children ? "flex" : "none" }}
            >
              {children}
            </div>
            <div
              className="betsReport-selectors"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <div className="betsReport-selector" data-testid="filter-sport">
                <span>{AppStrings.SPORT}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedSports}
                  handleChange={(value) => handleSportChange(value)}
                  allOptions={sports}
                  clearOptions={() => handleSportChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-league">
                <span>{AppStrings.LEAGUE}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedLeagues}
                  handleChange={(value) => handleLeagueChange(value)}
                  allOptions={leagues}
                  clearOptions={() => handleLeagueChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-match">
                <span>{AppStrings.MATCH}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMatch}
                  handleChange={(value) => handleMatchChange(value)}
                  allOptions={matches}
                  clearOptions={() => handleMatchChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-min-bet">
                <span>{AppStrings.MIN_BET_AMOUNT}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinBetAmount}
                  handleChange={(value) => handleBetAmountChange(value)}
                  allOptions={[]}
                  clearOptions={() => handleBetAmountChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-bet-type">
                <span>{AppStrings.BET_TYPE}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedBetType}
                  onChange={(value) => handleBetTypeChange(value)}
                  options={betTypes}
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-market-type">
                <span>{AppStrings.MARKET_TYPE}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMarketType}
                  handleChange={(value) => handleMarketTypeChange(value)}
                  allOptions={marketTypes}
                  clearOptions={() => handleMarketTypeChange(null)}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-min-ccf">
                <span>{AppStrings.MIN_CCF}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMinCCF}
                  handleChange={(value) => handleMinCCFChange(value)}
                  clearOptions={() => handleMinCCFChange(null)}
                  allOptions={minCCF}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-max-ccf">
                <span>{AppStrings.MAX_CCF}</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedMaxCCF}
                  handleChange={(value) => handleMaxCCFChange(value)}
                  clearOptions={() => handleMaxCCFChange(null)}
                  allOptions={maxCCF}
                  selector="value"
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-odds-provider">
                <span>{AppStrings.ODDS_PROVIDER}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedOddProvider}
                  onChange={(value) => handleOddProviderChange(value)}
                  options={oddsProviders}
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-status">
                <span>{AppStrings.STATUS}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedStatus}
                  onChange={(value) => handleStatusChange(value)}
                  options={statuses}
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-pre-match-live">
                <span>{AppStrings.PRE_MATCH_LIVE}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedPreMatchLive}
                  onChange={(value) => handlePreMatchLiveChange(value)}
                  options={preMatchLive}
                />
              </div>
              <div className="betsReport-selector" data-testid="filter-money-type">
                <span>{AppStrings.MONEY_TYPE}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedMoneyType}
                  onChange={(value) => handleMoneyTypeChange(value)}
                  options={moneyTypes}
                />
              </div>
            </div>

            {showExtraFilters && (
              <div className="drag-resize-buttons-container">
                <Popover content="Resize Mode">
                  <button
                    type="button"
                    data-testid="mode-resize-btn"
                    className={modeState === "resize" ? "active" : null}
                    onClick={() => setModeState("resize")}
                  >
                    <FullscreenOutlined />
                  </button>
                </Popover>
                <Popover content="Drag Mode">
                  <button
                    type="button"
                    data-testid="mode-drag-btn"
                    className={modeState === "drag" ? "active" : null}
                    onClick={() => setModeState("drag")}
                  >
                    <DragOutlined />
                  </button>
                </Popover>
                <button onClick={handleExpandAllRows}>  
                  {expandAllRows ? AppStrings.COLLAPSE_ALL : AppStrings.EXPAND_ALL}
                </button>
              </div>
            )}
            {showExtraFilters && (
              <div className="betsReport-selector-action-buttons">
                <button className="clear" onClick={() => handleClearFilters()}>
                  {AppStrings.CLEAR_FILTERS}
                </button>
                <button className="apply" onClick={() => handleApplyFilters()}>
                  {AppStrings.APPLY}
                </button>
              </div>
            )}
            {isApiRunning ? (
              <RebetLoader height={"100px"} width={"100px"} />
            ) : (
              <div className="betsReport-kpis-table" ref={tableRef}>
                <DragAndDropTable
                  columns={columns}
                  data={betsToShowInTable}
                  mode={modeState}
                  expandAllRows={expandAllRows}
                />
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default BetsReport;
